<h1 cds-text="title">View Platform</h1>
<app-view-platform *ngIf="!notFound" [platform$]="platform"></app-view-platform>
<clr-alerts *ngIf="notFound">
  <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
    <clr-alert-item>
      <span>Platform not found</span>
    </clr-alert-item>
  </clr-alert>
</clr-alerts>
